import { useContext, useEffect, useState } from "react";
import { Space } from "../Layout";
import { Link } from "react-router-dom";

const Pagination = (props) => {
  const [all, setAll] = useState(0);

  const args = {
    postType: props.postType,
    page: props.page,
    perPage: props.perPage,
    category: props.category,
  }

  useEffect(() => {
    fetch(`${tmp_path.site_url}/wp-json/my-api/v1/my-custom-endpoint?name=${args.postType}`)
      .then(response => response.json())
      .then(data => {
        let setCount = props.count ?? Number(data.count.publish);
        // console.log(setCount);
        let page = setCount / args.perPage;
        setAll(Math.ceil(page));
      })
  }, [props.count])

  const BeforeItem = () => {
    let Items = [];
    for (let i = (Number(args.page) - 1), len = (i - 2); i > len; i--) {
      if (i > 0) {
        Items.push(<Item key={i} active='' index={i} />)
      }
    }
    Items = Items.reverse()
    return (
      <>
        {Number(args.page) !== 1 &&
          <Item active='' index={Number(args.page) - 1} type='prev' />
        }
        {Items}
      </>
    );
  }

  const AfterItem = () => {
    let Items = [];
    for (let i = Number(args.page), len = all; i < len; i++) {
      if (i <= (Number(args.page) + 1)) {
        Items.push(<Item key={i} active='' index={i + 1} />)
      }
    }
    return (
      <>
        {Items}
        {Number(args.page) !== all &&
          <Item active='' index={Number(args.page) + 1} type='next' />
        }
      </>
    );
  }

  // console.log('category: ' + args.category)

  const Item = (props) => {
    let viewText;
    if (props.type == 'next') {
      viewText = '次へ';
    } else if (props.type == 'prev') {
      viewText = '前へ';
    } else {
      viewText = props.index;
    }

    return (
      <>
        <li>
          <Link
            to={`/${args.postType}${args.category ? '/' + args.category : ''}/page/${props.index}`}
            className={props.type ? "c-pagination__items--type c-pagination__items" : "c-pagination__items c-text--en c-text--bold"}
            data-state={props.active}
            onClick={(() => {
            })}
          >
            <p className={`c-text__med c-text--bold c-text--en ${props.active ? 'c-text--white' : ''} ${props.type ? '' : ''}`}>
              {viewText}
            </p>
          </Link>
        </li>
      </>
    )
  }

  // console.log(all);

  if (all !== 0) {
    return (
      <>
        <Space size={['64px auto 0', '48px 0 0']}>
          <div className="l-row">
            <ul className="c-pagination__list">
              <BeforeItem></BeforeItem>
              <Item active='active' to="" index={args.page} />
              <AfterItem></AfterItem>
            </ul>
          </div>
        </Space>
      </>
    )
  }
}

export default Pagination;
